import styled from 'styled-components/macro';
import { themeGet } from '@styled-system/theme-get';

export const StyledEditable = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
  padding: 10px;
  width: 80px;
  height: 46px;
  line-height: 1.5;
  border-width: 1px;
  border-style: solid;
  border-color: ${themeGet('colors.input.border')};
  font-weight: ${themeGet('fontWeights.semi')};
  background-color: #f1f1f1;
  border-radius: ${themeGet('radii.small')};
  font-size: ${themeGet('fontSizes.base')}px;
  color: ${themeGet('colors.primary.extra')};

  &:empty:before {
    content: attr(placeholder);
  }

  &:empty:focus::before {
    content: '';
  }

  &:focus {
    outline: none;
    border-color: ${themeGet('colors.input.focus')};
  }
`;
